import Vue from 'vue'
// 获取图片验证码
export const getVerifyCodeImg = () =>
  Vue.prototype.$get(`/reg/getVerifyCodeImg`, {
    random: `${Math.floor(100 * Math.random())}`,
    responseType: 'text',
  })
// 获取短信验证码
export const getVerifyMessage = data =>
  Vue.prototype.$post('/api/reg/getVerifyCode', { origin:'newDwap', ...data })
// 注册
export const join = data => Vue.prototype.$post('/api/reg/join', { origin:'newDwap', ...data })
// 登录
export const login = data => Vue.prototype.$post('/api/reg/login', { origin:'newDwap', ...data })
// 转换报名类型（新）
export const transformJoinType = data => Vue.prototype.$gw('/resource/dw/ucar/recruit/v1/changePersonMode', data)
// 获取新招募进度（新）
export const getRecruitProgress = data => Vue.prototype.$gw('/resource/dw/ucar/recruit/v1/getRecruitInfo', data)
// 新 OCR识别身份证（新）
export const readIdCard = data => Vue.prototype.$gw('/resource/dw/ucar/recruit/v1/recognizeIdCardInfo', data, false, false)
// 新 OCR识别驾驶证（新）
export const readDriverLicense = data => Vue.prototype.$gw('/resource/dw/ucar/recruit/v1/recognizeDriverLicenseInfo', data, false, false)
// 新 OCR识别行驶证（新）
export const readVehicleLicense = data => Vue.prototype.$gw('/resource/dw/ucar/recruit/v1/recognizeVehicleLicenseInfo', data, false, false)
// 新 校验司机身份信息（新）
export const validateDriverInfo = data => Vue.prototype.$gw('/resource/dw/ucar/recruit/v1/validateDriverInfo', data)
// 新 校验司机车辆信息(新)
export const validateVehicleInfo = data => Vue.prototype.$gw('/resource/dw/ucar/recruit/v1/validateVehicleInfo', data)
// 新 提交司机身份信息（新）
export const submitDriverInfo = data => Vue.prototype.$gw('/resource/dw/ucar/recruit/v1/subDriverInfo', data)
// 新 提交司机车辆信息（新）
export const submitVehicleInfo = data => Vue.prototype.$gw('/resource/dw/ucar/recruit/v1/subVehicleInfo', data)
// 签约（新）
export const sign = data => Vue.prototype.$gw('/resource/dw/ucar/recruit/v1/sign', data)
// 人脸识别后验证信息接口
export const checkStatusAfterFaceCompare = data => Vue.prototype.$gw('/resource/dw/ucar/recruit/v1/supDataAfterCheck', data, true)
// 获取车型数据
export const getVehicleDict = () => Vue.prototype.$gw('/resource/dw/ucar/recruit/getVehicleModeInfo')



// 车队登录
export const teamLogin = data => login({ type: 'team', ...data })
// 获取民族列表
export const getNations = () =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/getNations')
// 获取招聘来源列表（新）
export const getRecruitSources = () =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/getRecruitSource')
// 获取户籍城市列表（新）
export const getHouseHoldCities = () =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/getHouseHoldCity')
// 获取服务城市列表（新）
export const getServiceCities = data =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/getServiceCity', data || {})
// 获取服务城市招募文案（新）
export const getRecruitTextByCityId = cityId =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/getCityRecruitInfo', {
    cityId,
  })
// 验证个人信息
export const validPersonInfo = data =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/recruitBaseInfoValidate', data)
// 验证车辆信息
export const validCarInfo = data =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/vehicleInfoValidate', data)
// 上传图片
export const uploadImg = (imgData, imgType) =>
  Vue.prototype.$gw('/resource/du/ucar/base/uploadFile', {
    uploadFileType: imgType,
    imgData: imgData,
  })
// 提交用户填写的所有信息
export const submitRegInfo = data =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/subDriverRecruitInfo', data)
// 获取用户提交的注册信息（老版）
export const getRegInfoOld = id =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/queryC2CDriverInfo', {
    id,
  })
// 获取当前招募进度（新）
export const getRecruitStatus = (id, type) =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/getRecruitInfo', {
    id,
    recruitType: type,
  })
// 获取车队当前招募进度
export const getTeamRecruitStatus = id =>
  Vue.prototype.$gw(
    '/resource/dw/ucar/recruit/getCoCompanyRecruitProcessInfo',
    {
      recruitId: id,
    }
  )
// 激活当前车队
export const activatingTeam = data =>
  Vue.prototype.$gw(
    '/resource/dw/ucar/recruit/setCocompanyAccount',
    data
  )
// 获取面试时间列表
export const getAppointmentTime = (id, type) =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/getAppointInterviewInfo', {
    id,
    recruitType: type,
  })
// 提交预定的面试时间
export const bookingInterviewTime = (id, type, appointTimeId) =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/subAppointInterview', {
    id,
    recruitType: type,
    appointTimeId,
  })
// 获取审核未通过的信息
export const getUnapproveInfo = (id, type) =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/getUnapproveInfo', {
    id,
    recruitType: type,
  })
// 提交车队招募信息（新）
export const submitTeamInfo = data =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/submitRecruit', data)
// 重新提交未通过审核的信息
export const reSubmitRegInfo = data =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/reSubRecruitInfo', data)
// OCR智能识别身份证信息
export const spotIdCard = data =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/getIdCardInfo', data, false)
// OCR智能识别驾驶证信息
export const spotDriverLicense = data =>
  Vue.prototype.$gw(
    '/resource/dw/ucar/recruit/getDriverLicenseInfo',
    data,
    false
  )
// OCR智能识别行驶证信息（新）
export const spotVehicleLicense = data =>
  Vue.prototype.$gw(
    '/resource/dw/ucar/recruit/getVehicleLicenseInfo',
    data,
    false
  )
// 转为无车
export const convertToNocar = id =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/updateDriverHasCar', { id })
// 转为个人司机
export const convertToNormal = id =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/changePersonMode', { id })
// 获取老用户招募信息
export const getOldRecruitInfo = id =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/queryC2CDriverInfo', {
    id,
  })
// 获取企业名称（新）
export const getCompanyName = companyId =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/getEntRecruitHomePage', {
    companyId,
  })
// 获取企业简介（新）
export const getCompanyInfo = companyId =>
  Vue.prototype.$gw('/resource/dw/ucar/recruit/getCompanyInfo', {
    companyId,
  })

// 获取唇语
export const getFaceCode = data =>
  Vue.prototype.$gw('/resource/du/ucar/recruit/getFaceCode', data)

// 上传视频文件
export const uploadVideo = data =>
  Vue.prototype.$gw('/resource/du/ucar/base/uploadVideo', data, false, false)

// 人脸识别
export const faceCompare = data =>
  Vue.prototype.$gw('/resource/du/ucar/recruit/faceCompare', data, false, false)

// 查询人脸识别&征信审核状态接口
export const queryUploadStatus = data =>
  Vue.prototype.$gw('/resource/du/ucar/recruit/queryUploadStatus', data, false, false)

export const preCheckForUploadVideo = data =>
  Vue.prototype.$gw('/resource/du/ucar/recruit/uploadVideoCheck', data, false)

// 查询人脸识别结果
export const queryFaceStatus = data =>
Vue.prototype.$gw('/resource/du/ucar/recruit/queryFaceStatus', data)

// 获取培训全局配置
export const getTrainConfig = data =>
  Vue.prototype.$gw('/resource/dw/ucar/edu/baseConfig', data)

// 获取课程列表
export const getLessonList = data =>
  Vue.prototype.$gw('/resource/dw/ucar/edu/getMyCourseList', data)

// 获取课程具体内容
export const getLessDetail = data =>
  Vue.prototype.$gw('/resource/dw/ucar/edu/courseDetails', data)

// 同步课程学习时间
export const LessonSyncRefresh = data =>
  Vue.prototype.$gw('/resource/dw/ucar/edu/syncRefreshTime', data)

// 查询考试状态
export const queryExamStatus = data =>
  Vue.prototype.$gw('/resource/dw/ucar/edu/coursePostTest', data)

// 开始考试
export const startExam = data =>
  Vue.prototype.$gw('/resource/dw/ucar/edu/takeExam', data)

// 获取下一题
export const getNextQuestion = data =>
  Vue.prototype.$gw('/resource/dw/ucar/edu/nextSubject', data)

// 交卷
export const examCommit = data =>
  Vue.prototype.$gw('/resource/dw/ucar/edu/examCommit', data)

// 新招募单司机类型转换
export const transformNewJoinType = data => Vue.prototype.$gw('/resource/dw/ucar/enlist/changeChannel', data)
// 校验司机车辆信息(new-vehicle-info)
export const validateNewVehicleInfo = data => Vue.prototype.$gw('/resource/dw/ucar/enlist/validateVehicleInfo', data)
// 提交司机车辆信息(new-vehicle-info)
export const submitNewVehicleInfo = data => Vue.prototype.$gw('/resource/dw/ucar/enlist/subVehicleInfo', data)
// 获取招募单信息
export const getEnlist = data => Vue.prototype.$gw('/resource/dm/ucar/enlist/getEnlist', data)
// 获取城市招募配置
export const getCityConfig = data => Vue.prototype.$gw('/resource/dw/ucar/enlist/getCityConfig', data)
// 获取城市招募司机要求
export const getDriverConfig = data => Vue.prototype.$gw('/resource/dm/ucar/enlist/getDriverConfig', data)
// 变更招募身份
export const changeIdentity = data => Vue.prototype.$gw('/resource/dm/ucar/enlist/changeIdentity', data)
// 车辆提报审核未通过原因
export const getVehicleInfo = data => Vue.prototype.$gw('/resource/dm/ucar/enlist/getVehicleInfo', data)
// 熊然
// 校验司机身份信息(new-driver-info)
export const validateNewDriverInfo = data => Vue.prototype.$gw('/resource/dw/ucar/enlist/validateDriverInfo', data)
// 提交司机身份信息(new-driver-info)
export const submitNewDriverInfo = data => Vue.prototype.$gw('/resource/dw/ucar/enlist/subDriverInfo', data)
// 签约（新）
export const signNew = data => Vue.prototype.$gw('/resource/dw/ucar/enlist/sign', data)
// 提交司机身份信息 (精简)
export const submitSimpleDriverInfo = data => Vue.prototype.$gw('/resource/dw/ucar/enlist/subSimpleDriverInfo', data)
// 获取新招募进度
export const getNewRecruitProgress = data => Vue.prototype.$gw('/resource/dw/ucar/enlist/getEnlistInfo', data)
// 双证上传
export const credentialsUpload = data => Vue.prototype.$gw('/resource/dm/ucar/driver/putEnListCarOnlineInfo',data)
// 查询配置中心（进度查询页配置开关）
export const gaeaQuery = data=> Vue.prototype.$gw('/resource/dw/ucar/common/gaea',data)
// 注册信息详情（审核不通过弹窗）
export const appDriverInfo = data=> Vue.prototype.$gw('/resource/dm/ucar/enlist/getRegisterInfo',data)
// 双证信息详情（审核不通过弹窗）
export const appCredentialsInfo = data=> Vue.prototype.$gw('/resource/dm/ucar/enlist/getDoubleCertificateInfo',data)

export default {
  getVerifyCodeImg,
  login,
  teamLogin,
  getNations,
  getRecruitSources,
  getTeamRecruitStatus,
  activatingTeam,
  getHouseHoldCities,
  getServiceCities,
  validPersonInfo,
  validCarInfo,
  uploadImg,
  submitRegInfo,
  getRegInfoOld,
  getRecruitStatus,
  getAppointmentTime,
  bookingInterviewTime,
  getUnapproveInfo,
  reSubmitRegInfo,
  spotIdCard,
  spotDriverLicense,
  spotVehicleLicense,
  convertToNocar,
  getOldRecruitInfo,
  getCompanyInfo,
}
